import clsx from 'clsx';

export default function LogoIcon({
  className,
  classNameLogo,
  classNameTitle,
}: {
  className?: string;
  classNameLogo?: string;
  classNameTitle?: string;
}) {
  return (
    <svg
      className={clsx(className, 'hover:opacity-80')}
      viewBox="0 0 327 123"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="currentColor"
        className={clsx('main', ['currentColor', classNameTitle])}
      >
        <path
          className="cls-1"
          d="M29.79,94.98l-17.5-1.79c-2.98-.3-4.05-1.07-4.05-4.05v-2.03c0-2.98,1.01-4.06,4.05-4.06h13.69c2.98,0,4.05,1.07,4.05,4.06v.42h3.01l4.37-2.52c-.16-5.49-2.89-7.98-8.46-7.98H9.06c-5.79,0-8.47,2.62-8.47,8.47v5.43c0,5.91,2.68,8,8.47,8.47l17.5,1.85c2.99,.3,4.06,1.07,4.06,4.06v3.4c0,2.98-1.07,4.06-4.06,4.06H11.45c-3.04,0-4.05-1.07-4.05-4.06v-1.16h-2.34l-5.05,2.92c.05,5.74,2.73,8.32,8.47,8.32H29.79c5.73,0,8.47-2.62,8.47-8.47v-6.86c0-5.91-2.74-7.94-8.47-8.47"
        />
        <path
          className="cls-1"
          d="M139.42,98.27h-20.27v-1.76c0-4.09,1.32-5.35,5.41-5.35h9.44c4.09,0,5.41,1.26,5.41,5.35v1.76Zm-3.08-12.71h-14.36c-7.36,0-10.45,2.96-10.45,10.45v12.34c0,7.49,3.09,10.45,10.45,10.45h15.86c6.04,0,8.94-2.77,8.94-8.94v-.97h-7.38c-.11,2.83-1.32,3.87-4.27,3.87h-10.58c-4.09,0-5.41-1.26-5.41-5.35v-4.21h27.63v-7.18c0-7.49-3.08-10.45-10.45-10.45"
        />
        <path
          className="cls-1"
          d="M182.41,107.27c0,4.09-1.26,5.35-5.35,5.35h-4.53c-3.52,0-5.92-.5-8.18-2.2l-2.52-1.89v-12.71l2.52-1.89c2.26-1.7,4.66-2.2,8.18-2.2h4.53c4.09,0,5.35,1.26,5.35,5.35v10.2Zm-2.83-21.71h-4.59c-6.11,0-8.69,.5-13.09,4.15l-.07,.06v-15.79h-3.23l-4.45,2.57v42.24h3.16l4-2.31v-2.28s.58,.44,.58,.44c4.41,3.65,6.98,4.15,13.09,4.15h4.59c7.36,0,10.45-2.96,10.45-10.45v-12.34c0-7.49-3.09-10.45-10.45-10.45"
        />
        <path
          className="cls-1"
          d="M222.65,109.47l-2.89,2.14c-2.08,1.51-3.78,1.95-6.93,1.95h-6.42c-2.84,0-3.78-.95-3.78-3.78v-1.76c0-2.77,.94-3.78,3.78-3.78h16.24v5.22Zm7.62-13.47c0-7.49-3.09-10.45-10.45-10.45h-14.35c-6.04,0-8.94,2.77-8.94,8.94v.93h7.36c0-3.2,1.2-4.26,4.28-4.26h9.06c4.09,0,5.41,1.2,5.41,5.29v3.27h-19.83c-5.16,0-7.8,2.58-7.8,7.81v3.46c0,5.29,2.64,7.81,7.8,7.81h7.62c5.66,0,7.62-.38,11.65-3.65l1.07-.82v2.33l3.71,2.14h3.4v-22.79Zm0,0"
        />
        <path
          className="cls-1"
          d="M260.26,85.55h-13.47c-7.37,0-10.45,2.96-10.45,10.45v12.34c0,7.49,3.08,10.45,10.45,10.45h13.47c7.37,0,10.45-2.96,10.45-10.45v-1.74h-7.43v.67c0,4.09-1.19,5.35-5.29,5.35h-8.69c-4.09,0-5.29-1.26-5.29-5.35v-10.2c0-4.09,1.2-5.35,5.29-5.35h8.69c3.91,0,5.18,1.16,5.28,4.84h7.44v-.55c0-7.49-3.08-10.45-10.45-10.45"
        />
        <path
          className="cls-1"
          d="M99.73,86.25c0-3.14,1.2-4.28,4.28-4.28h5.26v-6.11h-8.22c-6.04,0-8.94,2.77-8.94,8.94v4.7l-.09,.04-5.57,3.22v2.87h5.66v23.16h7.61v-23.16h5.97v-6.1h-5.97v-3.27Zm0,0"
        />
        <path
          className="cls-1"
          d="M293.71,102.02l5.15-4.71,1.55-1.42,11.32-10.34h-9.88l-13.08,12.03-4.16,3.83v-29.36h-3.47l-4.21,2.43v44.31h7.68v-8.47l4.01-3.66,.08,.07,13.41,12.05h10.24l-18.65-16.77Zm0,0"
        />
        <path
          className="cls-1"
          d="M72.76,109.47l-2.9,2.14c-2.08,1.51-3.78,1.95-6.93,1.95h-6.42c-2.83,0-3.78-.95-3.78-3.78v-1.76c0-2.77,.94-3.78,3.78-3.78h16.24v5.22Zm7.62-13.47c0-7.49-3.08-10.45-10.45-10.45h-14.35c-6.04,0-8.94,2.77-8.94,8.94v.93h7.36c0-3.2,1.2-4.26,4.28-4.26h9.07c4.09,0,5.41,1.2,5.41,5.29v3.27h-19.83c-5.16,0-7.8,2.58-7.8,7.81v3.46c0,5.29,2.64,7.81,7.8,7.81h7.62c5.66,0,7.62-.38,11.64-3.65l1.07-.82v2.33l3.71,2.14h3.4v-22.79Zm0,0"
        />
        <path
          className="cls-1"
          d="M322.07,90.91c.81,0,1.27-.38,1.27-1.03s-.46-1.02-1.27-1.02h-1.07v2.04h1.07Zm1.33,.76l1.27,1.98h-1.24l-1.13-1.76h-1.29v1.76h-1.24v-5.78h2.37c1.5,0,2.39,.79,2.39,2.01,0,.86-.4,1.48-1.14,1.79m3.06-.81c0-2.57-1.87-4.54-4.44-4.54s-4.48,2.01-4.48,4.57,1.9,4.57,4.45,4.57,4.47-2.02,4.47-4.6m.87,0c0,3.05-2.34,5.44-5.34,5.44s-5.31-2.39-5.31-5.41,2.31-5.41,5.34-5.41,5.31,2.33,5.31,5.38"
        />
      </g>
      <g
        className={clsx('mountain', ['currentColor', classNameLogo])}
        fill="currentColor"
      >
        <path
          className="cls-1"
          d="M74.71,66.46l-9.16-9.16-2.83,1.63,7.52,7.52h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M68.23,55.76l10.7,10.7h4.46l-12.33-12.33-2.83,1.63Zm0,0"
        />
        <path
          className="cls-1"
          d="M92.06,66.46l-15.5-15.51-2.83,1.63,13.88,13.88h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M100.73,66.46l-18.68-18.68-2.83,1.63,17.05,17.05h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M109.41,66.46l-21.85-21.86-2.82,1.63,20.22,20.23h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M118.08,66.46l-25.03-25.03-2.82,1.63,23.4,23.4h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M126.76,66.46l-28.21-28.21-2.83,1.63,26.57,26.57h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M135.43,66.46l-31.38-31.38-2.83,1.63,29.75,29.75h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M52.91,66.46h4.46l-2.8-2.81-2.83,1.63-2,1.15,.02,.02h3.14Zm0,0"
        />
        <path
          className="cls-1"
          d="M66.04,66.46l-5.98-5.98-2.82,1.63,4.35,4.35h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M144.1,66.46L109.55,31.9l-2.83,1.63,32.92,32.93h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M152.78,66.46L115.05,28.72l-2.82,1.63,36.1,36.1h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M161.45,66.46L120.55,25.55l-2.83,1.63,39.28,39.28h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M170.13,66.46L126.05,22.37l-2.83,1.63,42.45,42.45h4.46Zm0,0"
        />
        <path
          className="cls-1"
          d="M178.17,66.46l-34.71-34.71-2.02,1.17,33.54,33.54h3.19Zm0,0"
        />
        <path
          className="cls-1"
          d="M186.84,66.46l-37.88-37.88-2.02,1.17,36.72,36.71h3.18Zm0,0"
        />
        <path
          className="cls-1"
          d="M195.52,66.46l-41.06-41.06-2.02,1.16,39.89,39.89h3.18Zm0,0"
        />
        <path
          className="cls-1"
          d="M204.19,66.46l-44.23-44.23-2.02,1.16,43.06,43.07h3.19Zm0,0"
        />
        <path
          className="cls-1"
          d="M212.86,66.46l-47.4-47.41-2.02,1.17,46.24,46.24h3.18Zm0,0"
        />
        <path
          className="cls-1"
          d="M221.54,66.46L170.96,15.88l-2.02,1.16,49.42,49.42h3.18Zm0,0"
        />
      </g>
      <g
        className={clsx('lower', ['currentColor', classNameLogo])}
        fill="currentColor"
      >
        <path
          className="cls-1"
          d="M216.6,22.84l13.76,13.76h1.5l4.08,4.08v1.5l24.27,24.27h4.69L198.46,0l-2.02,1.16,20.17,20.17v1.5Zm0,0"
        />
        <path
          className="cls-1"
          d="M207.92,30.04v1.5l14.84,14.84h1.5l.02-.02,5.59,5.59-.02,.02v1.5l12.98,12.98h4.73L187.46,6.35l-2.02,1.16,22.51,22.51-.02,.02Zm0,0"
        />
        <path
          className="cls-1"
          d="M201.11,14.52v1.5l24.97,24.97h1.5s7.43,7.42,7.43,7.42h0v1.51l16.53,16.53h4.69L192.96,3.18l-2.02,1.16,10.18,10.18h0Zm0,0"
        />
        <path
          className="cls-1"
          d="M207.97,47.41v1.5l6.04,6.04h1.51s3.21,3.21,3.21,3.21h0v1.51l6.8,6.8h4.7L176.46,12.7l-2.02,1.17,33.53,33.53h0Zm0,0"
        />
        <path
          className="cls-1"
          d="M200.02,30.77v1.5l14.74,14.74h1.5s3.67,3.67,3.67,3.67h0v1.51l14.26,14.27h4.7L181.96,9.52l-2.02,1.17,20.08,20.08h0Zm0,0"
        />
      </g>
    </svg>
  );
}
